export function usingHookOrDefault(usingHook, defaultHook) {
    return !usingHook
        ? defaultHook
        : function (config) {
            return usingHook;
        };
}
//# sourceMappingURL=usingHookOrDefault.js.map